import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getBowltypesData(context) {
      const response = await Vue.axios.get(`${URL_API}bowltype`);
      let data = response["data"];
      context.commit("updateBowltypesData", data);
    },
    async createBowltypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}bowltype/store`, body, config);
      context.dispatch("getBowltypesData");
    },
    async pushBowltypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}bowltype/update`, body, config);
      context.dispatch("getBowltypesData");
    },
    async destroyBowltypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}bowltype/destroy`, body, config);
      context.dispatch("getBowltypesData");
    }
  },
  mutations: {
    updateBowltypesData(state, bowltypesData) {
      state.bowltypesData = bowltypesData;
    }
  },
  state: {
    bowltypesData: []
  },
  getters: {
    allBowltypesData(state) {
      return state.bowltypesData;
    }
  }
};